import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isRegistered: false,
  firstName: '',
  lastName: '',
  mobileNumber: '',
  emailAddress: '',
  password: '',
  confirmPassword: '',
  passwordsMatch: false,
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    isRegistered: (state, action) => {
      state.isRegistered = action.payload;
    },
    firstName: (state, action) => {
      state.firstName = action.payload;
    },
    lastName: (state, action) => {
      state.lastName = action.payload;
    },
    mobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    emailAddress: (state, action) => {
      state.emailAddress = action.payload;
    },
    password: (state, action) => {
      state.password = action.payload;
    },
    confirmPassword: (state, action) => {
      state.confirmPassword = action.payload;
    },
    passwordsMatch: (state, action) => {
      state.passwordsMatch = state.password == '' || state.confirmPassword == '' ? false : state.password == state.confirmPassword ? true : false;
    }
  }
});

export const {
  isRegistered,
  firstName,
  lastName,
  mobileNumber,
  emailAddress,
  password,
  confirmPassword,
  passwordsMatch,
} = registrationSlice.actions;
export default registrationSlice.reducer;

export const selectIsRegistered = (state) => state.registration.isRegistered;
export const selectFirstName = (state) => state.registration.firstName;
export const selectLastName = (state) => state.registration.lastName;
export const selectMobileNumber = (state) => state.registration.mobileNumber;
export const selectEmailAddress = (state) => state.registration.emailAddress;
export const selectPassword = (state) => state.registration.password;
export const selectConfirmPassword = (state) => state.registration.confirmPassword;